export const SelectLabel = ({ chipDefaultValue, value }) => {
  return value?.label || chipDefaultValue;
};
